import Switch from '@carvana/ds-switch';
import { SearchSource } from '@carvana/merch-contracts';
import VehicleOffering from '@carvana/merch-contracts/VehicleOffering';
import cx from 'classnames';
import { useContext } from 'react';
import AnimateHeight from '@/common/AnimateHeight';
import FilterEvents from '~/constants/srp/events';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import { useHasNewCarFacet } from '~/hooks/srp/selectors';

type OwnProps = {
  inModal: boolean;
};

export default function Offering({ inModal }: OwnProps) {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const hasAppliedFilters = Object.keys(appliedFilters || {}).length > 0;
  const hasOfferingsFilter = useHasNewCarFacet();
  const trackEvent = useTrackEvent();

  const isFilteringNewOnly =
    appliedFilters?.offerings?.includes(VehicleOffering.New) ?? false;

  const handleToggle = () => {
    setSearchSource(SearchSource.Facet);

    updateListFilter({
      filterKey: 'offerings',
      value: VehicleOffering.New
    });

    trackEvent(FilterEvents.engagedFacet, {
      action: `${isFilteringNewOnly ? 'remove' : 'add'} facet`,
      item: 'switch',
      label: 'offerings',
      value: 'Only brand new cars'
    });
  };

  return (
    <AnimateHeight show={hasOfferingsFilter}>
      <div
        className={cx('border-b border-border-subtle px-2xl pb-2xl', {
          'pt-2xl': hasAppliedFilters || inModal
        })}
      >
        <div className="flex justify-between text-text-strong t-strong-sm">
          <p>Only Brand New Cars</p>
          <Switch
            data-testid="new-cars-only-toggle"
            checked={isFilteringNewOnly}
            onChange={handleToggle}
          />
        </div>
      </div>
    </AnimateHeight>
  );
}
